import React from 'react';
import { Link } from 'react-router-dom';
import styles from './DashboardCardLayout.module.scss';

function DashboardCardLayout(props) {
  const { title, isDualLayout, children, leftContent, icon, isCustom, extraComponent, clickAction } = props;

  const renderDualLayout = () => {
    return (
      <>
        {isCustom ? (
          <div className={styles.flexColumn}>
            {leftContent}
            <h4 className={styles.title}>{title}</h4>
          </div>
        ) : (
          <div className={styles.flexColumn}>
            <img width="90px" src={icon} alt="icon" />
            <h4 className={styles.title}>{title}</h4>
          </div>
        )}
        <span className={styles.divider} />
        <div className={styles.flexColumn}>{children}</div>
      </>
    );
  };

  const renderSingleLayout = () => {
    return <div className={styles.singleFlexColumn}>{children}</div>;
  };

  return (
    <Link to={clickAction || ''}>
      <div className={clickAction ? styles.clickableCard : styles.cardContainer}>
        <h6>{title}</h6>
        <div className={styles.innerContainer}>{isDualLayout ? renderDualLayout() : renderSingleLayout()}</div>
        {extraComponent && <div className={styles.extraComponent}>{extraComponent}</div>}
      </div>
    </Link>
  );
}

export default DashboardCardLayout;
